---
nb:
  budget_actions:
    create_custom_budget: Opprett tilpasset budsjett
    learn_more: Hvordan beregnes prognoser?
    update_import: Oppdater budsjettdata
  budget_export:
    export_button: Eksporter budsjettdata
  budget_grouping:
    display: Visning
    view_by: Vis etter
  budget_import:
    description: Eksporter budsjettdata, endre den i Excel, og importer den oppdaterte XLSX-filen her. Kraftverk er i kolonner, måneder er i rader. Systemet vil automatisk oppdage året fra rad 4.
    invalid_file_type: Kun XLSX-filer støttes
    upload_error: Feil ved import av budsjettdata
    upload_success: Budsjettdata importert
    upload_success_with_details: Importerte %{count} budsjettposter for år %{year}
  budget_source:
    actual_budgets: Viser faktiske budsjettdata
    actual_message: Disse dataene reflekterer faktisk produksjon og inntekt fra fortiden.
    actual_title: Viser faktiske budsjettdata
    forecasted_budgets: Viser prognostiserte budsjettdata
    forecasted_message: Dette er beregnede prognoser basert på historiske mønstre. Opprett et tilpasset budsjett for å bruke dine egne verdier.
    forecasted_title: Viser prognostiserte budsjettdata
    imported_budgets: Viser importerte fremtidige budsjettdata
    imported_message: Du har lastet opp budsjettdata for dette året.
    imported_title: Viser importerte budsjettdata
  budgets_for: Budsjett for
  dialog:
    new_budget_forecast: Opprett Budsjettprognoser
    unavailable_price_areas: "%{price_areas} har allerde blitt opprettet. Klikk 'Produksjonsprofil' for å redigere"
  errors:
    messages:
      budget_already_saved: Budsjettet er allerede lagret!
      no_forcasts_for_this_year: Ingen prognoser for %{year}
      total_percent: total prosent må være eksakt 100
  profile:
    average: Gjennomsnitt
    price_chart: Prisdiagram
    price_profile: Prisprofil
    production_profile: Produksjonsprofil
    production_profile_chart: Produksjonsprofildiagram
    revenue_chart: Inntektsdiagram
    revenue_profile: Inntektsprofil
    save_budget: Lagre budsjett
    total: Total
    validations:
      non_negative: Kan ikke være negativ
      required: Obligatorisk
